export default "<div class=\"rm-app-content\">\n  <rm-loader></rm-loader>\n  <ng-template app-view-host></ng-template>\n</div>\n"